import { createApiSlice } from "@common";
import { CRUD_WORKING_TIME_TYPE } from "@routes";

const apiConfig = [
  { name: "addworkingTimeType",    method: "post",   url: CRUD_WORKING_TIME_TYPE, stateKey: "message" },
  { name: "getworkingTimeType",    method: "get",    url: CRUD_WORKING_TIME_TYPE, stateKey: "data"    },
  { name: "getworkingTimeTypeById",    method: "get",    url: CRUD_WORKING_TIME_TYPE, stateKey: "data"    },
  { name: "updateworkingTimeType", method: "put",    url: CRUD_WORKING_TIME_TYPE, stateKey: "message" },
  { name: "deleteworkingTimeType", method: "delete", url: CRUD_WORKING_TIME_TYPE, stateKey: "message" },
];

const customReducers = {
  initialState: { data: [], additionalData: [] },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("productType", apiConfig, customReducers);
const workingTimeTypeSlice = slice;

export default workingTimeTypeSlice.reducer;

export const { addworkingTimeType, getworkingTimeType,getworkingTimeTypeById, updateworkingTimeType, deleteworkingTimeType } = thunks;
export const { rowSelect } = actions;
